import type {Context} from '../types';

// Fix legacy lightbox video embed
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const embed = data.json && data.json.embed;

  return {
    needed: data.lightbox && embed,
    logData: {
      msg: 'Legacy video lightbox with data.json.embed',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      embed.type = 'video';
      embed.originalUrl = embed.url;
      data.json.items = [embed];
      // eslint-disable-next-line webflow/no-delete
      delete data.json.embed;
    },
  };
};
